import {
    DirectPromotionGoalUI,
    DirectSpendLimitType,
    DirectStrategyType,
} from '../data-layer/direct/types';

export const getContentPromotionGoalsSettings = (
    selectedGoals?: DirectPromotionGoalUI,
    strategyType?: DirectStrategyType,
    spendLimitType?: DirectSpendLimitType,
) => {
    const selectedGoalsLength = selectedGoals && Object.keys(selectedGoals).length;

    return {
        disableCost:
            strategyType === DirectStrategyType.MAX_CONVERSIONS &&
            (spendLimitType === DirectSpendLimitType.CRR ||
                spendLimitType === DirectSpendLimitType.WEEKLY_LIMIT) &&
            selectedGoalsLength === 1,
        showCostType:
            strategyType === DirectStrategyType.MAX_CONVERSIONS &&
            spendLimitType === DirectSpendLimitType.CRR &&
            selectedGoalsLength !== undefined &&
            selectedGoalsLength > 1,
    };
};
